const FRIENDREF_COOKIE = "friendRef";

export default FRIENDREF_COOKIE;
